/* eslint-disable react-hooks/exhaustive-deps */
import { IGRequest, IGResponse } from "@common/models";
import { IFreeUpgrade } from "@common/models/CMS/FreeUpgradeWinner";
import Alert from "@components/general/Alert";
import Divider from "@components/general/Divider";
import Button from "@components/general/form/Button";
import Panel from "@components/general/Panel";
import { IViewport } from "@config/appConfig";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { useApolloQuery } from "@service/graphql";
import { FREE_UPGRADE_WINNERS } from "@service/graphql/query/Query.FreeUpgradeWinners";
import Translate from "@service/Translate";
import { formatToDate, getAirport } from "@utilize/Format";
import { capitalizeFirstLetter } from "@utilize/Util";
import { FC, Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { controlData } from "./News";
import { Page } from "./page";

const FreeUpgrade: FC = () => {
    const { tr } = Translate;
    const { small } = Config.get<IViewport>("viewport");
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));
    const takeFreeUpgradeWinnersItem: number = width > small ? 10 : 8;
    const [dataState, setDataState] = useState<boolean>(false);
    const [FreeUpgradeWinnersList, setFreeUpgradeWinnersList] = useState<IFreeUpgrade[]>([]);
    const [skipDataState, setSkipDataState] = useState<IGRequest>({ first: takeFreeUpgradeWinnersItem + 1, skip: 0 });

    const { loading, error, data } = useApolloQuery<IGResponse<IFreeUpgrade[]>>(FREE_UPGRADE_WINNERS, {
        variables: {
            first: skipDataState.first,
            skip: skipDataState.skip
        }
    });

    useEffect(() => {
        if (data) {
            const [validData, dataStatus] = controlData<IFreeUpgrade>(data?.freeUpgradeWinner, takeFreeUpgradeWinnersItem);
            setFreeUpgradeWinnersList(FreeUpgradeWinnersList.concat(validData || []));
            setDataState(dataStatus);
        }
    }, [data]);

    const loadMore = () => {
        setSkipDataState((previousState) => ({ first: previousState.first, skip: previousState.skip + takeFreeUpgradeWinnersItem }));
    }

    return (
        <Page className='free-upgrade'>
            {
                error ? <Alert type="danger" variant="contain" title={tr("err_get_data")} /> :
                    <Panel>
                        <div className="free-upgrade-table">
                            <div className="row spa-0 free-upgrade-table-header">
                                <div className="col-1-auto table-header-columns full-name">{tr("full_name")}</div>
                                <div className="col-1-auto table-header-columns route">{tr("route")}</div>
                                <div className="col-1-auto table-header-columns flight-date">{tr("flight_date")}</div>
                            </div>
                            {
                                FreeUpgradeWinnersList?.map((item, index) => {
                                    const flightDate = item.flightDate + "T00:00:00Z";
                                    return (
                                        <Fragment key={index}>
                                            <div className="row spa-0 free-upgrade-table-content-row">
                                                <div className="col-1-auto col-sm-1-1 table-content-columns full-name trim">
                                                    <span className="prefix">{item.prefix}. </span>
                                                    <span>
                                                        {capitalizeFirstLetter(item.lastName as string)}
                                                    </span>
                                                </div>
                                                <div className="col-1-auto col-sm-1-1 table-content-columns route">
                                                    {getAirport(item.route?.contentItems[0].code?.code.split("-")[0]).cityName} - {getAirport(item.route?.contentItems[0].code?.code.split("-")[1]).cityName}
                                                </div>
                                                <div className="col-1-auto col-sm-1-1 table-content-columns flight-date">
                                                    {formatToDate(new Date(flightDate).getTime(), { format: width > small ? "d M Y" : "Y/m/d" }) || ""}
                                                </div>
                                            </div>
                                            <Divider mode="perforation" orientation="horizontal" />
                                        </Fragment>
                                    )
                                })
                            }
                        </div>
                        {
                            dataState ?
                                <div className="more-btn-container flex justify-center">
                                    <Button
                                        onClick={loadMore}
                                        icon="icon-chevron-down"
                                        iconPositin="end"
                                        text={tr("record_load_more")}
                                        variant="outlined"
                                        color="primary"
                                        width="200px"
                                        height="40px"
                                        loading={loading}
                                        className={dataState ? "" : " hide"}
                                    />
                                </div> : ""
                        }
                    </Panel>
            }
        </Page >
    )
}

export default FreeUpgrade;